<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.patrolLogDetail") }}</h3>
                <div>
                    <button
                        v-if="$store.getters.hasGatehousePerm('delete_patrollog')"
                        class="btn btn-sm btn-danger"
                        @click="deletePatrolLog"
                    >
                        <icon icon="Trash"></icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row g-4">
                    <div class="col-12 col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("patrolLog.status") }}</dt>
                            <dd class="col-sm-8 fw-bold">{{ patrolLog.finished_at ? $t("patrolLog.completed") : $t("patrolLog.inProgress") }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolLog.patrolRoute") }}</dt>
                            <dd class="col-sm-8">{{ patrolLog.patrol_route_name }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolLog.deviceName") }}</dt>
                            <dd class="col-sm-8">{{ patrolLog.device_name }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolLog.startedAt") }}</dt>
                            <dd class="col-sm-8">{{ patrolLog.started_at ? $d(new Date(patrolLog.started_at), "short") : "--" }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolLog.finishedAt") }}</dt>
                            <dd class="col-sm-8">{{ patrolLog.finished_at ? $d(new Date(patrolLog.finished_at), "short") : "Probiha" }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolLog.duration") }}</dt>
                            <dd class="col-sm-8">{{ patrolLog.duration === 0 ? "--" : patrolLog.duration }}</dd>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <MapView
                            :checkpoints="checkpoints"
                            :nfcTags="nfcTags"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-4">
            <div class="card-header">
                <h3>{{ $t("patrolLog.checkpoints") }}</h3>
            </div>
            <div class="card-body">
                <div v-if="!checkpoints.length" class="p-2 text-center text-muted">
                    {{ $t("patrolLog.noCheckpoints") }}
                </div>
                <ul v-else class="list-group list-group-flush">
                    <li
                        v-for="checkpoint in checkpoints"
                        :key="checkpoint"
                        :class="checkpoint.is_checked ? 'checkpoint-ok' : 'checkpoint-missing'"
                        class="list-group-item py-2 mb-2"
                    >
                        <div class="d-flex flex-column">
                            <div class="fw-bold text-white">{{ checkpoint.tag_name }}</div>
                            <div v-if="!checkpoint.is_checked" class="text-white">
                                {{ $t("patrolLog.notScanned") }}
                            </div>
                            <div v-else class="text-white">
                                {{ $t("patrolLog.isScanned") }}: {{ $d(new Date(checkpoint.scanned_at), 'long') }}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { deleteItem } from '@/utils/actions';
import MapView from '@/components/dashboard/MapView.vue';

export default {
    components: {
        Icon,
        MapView,
    },
    data() {
        return {
            patrolLog: {},
            checkpoints: [],
            nfcTags: [],
        }
    },
    created() {
        this.getPatrolLog();
        this.getCheckpoints();
    },
    methods: {
        getPatrolLog() {
            this.$store.getters.api.get(`/dashboard/${this.patrolLogslug}/patrol-logs/${this.patrolLogId}`)
            .then(res => {
                this.patrolLog = res.data;
            })
            .catch(error => {
                console.error("Error loading patrol log.", error);
            });
        },
        getCheckpoints() {
            this.$store.getters.api.get(`/dashboard/${this.patrolLogslug}/patrol-logs/${this.patrolLogId}/checkpoints`)
            .then(res => {
                this.checkpoints = res.data.checkpoints;
                this.nfcTags = res.data.nfc_tags;
            })
            .catch(error => {
                console.error("Error loading checkpoints.", error);
            });
        },

        deletePatrolLog() {
            deleteItem({
                api: this.$store.getters.api,
                slug: this.patrolLogslug,
                model: "patrol-logs",
                id: this.patrolLogId,
                confirmMessage: this.$t("patrolLog.delete"),
                redirect: "PatrolLogListView",
                router: this.$router,
            });
        }
    },
    computed: {
        patrolLogslug() {
            return this.$route.params.slug;
        },
        patrolLogId() {
            return this.$route.params.id;
        }
    }
}
</script>

<style scoped>
    .checkpoint-ok {
        background-color: #349b5f;
    }

    .checkpoint-missing {
        background-color: #e74c3c;
    }
</style>